module.exports = __webpack_public_path__ + "img/category-brand.15f0c370.png";